import React from 'react';
import { Box } from '@mui/material';
import CustomText, { textStyles } from "../../components/CustomText";
import { useMediaQuery,} from "@mui/material";
import { useTheme } from "@mui/material/styles";
const Card = ({ image, title, description, icons, isImageLeft }) => {
        const theme = useTheme();
        // const isMobile = useMediaQuery(theme.breakpoints.down("lg"));
                const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // e.g. below 600px
            const isTablet = useMediaQuery(theme.breakpoints.between("sm", "lg")); 
  return (
    <Box
      sx={{
        display: 'flex',
        // flexDirection: isImageLeft ? 'row' : 'row-reverse', 
        flexDirection: (isMobile || isTablet) ? 'column' : (isImageLeft ? 'row' : 'row-reverse'),
        flexWrap: (isMobile || isTablet)?"wrap":"nowrap",
        gap:"100px",
        justifyContent:"space-between",
        alignItems: 'center',
        marginBottom: '20px', // Space between the cards
        border: '1px solid #D1D3D9',  // Adding a border to the card
        borderRadius: '14px', 
        padding:0,
        paddingTop:isTablet?2:0,
        paddingBottom:isTablet?2:0,

      }}
    >
      <Box sx={{ flex: 1,p:0, marginBottom: 0 ,marginTop:0 }}>
        <img
          src={image}
          alt={title}
          style={{
            width: '100%',
            height: 'auto',
            display: 'block',
            marginBottom: 0,
            marginTop:0,
  borderRadius: isMobile
      ? '15px' // Mobile: rounded from all sides
      : isImageLeft
      ? '14px 0 0 14px' // Image on left: round top-left & bottom-left
      : '0 14px 14px 0',
          }}
        />
      </Box>
      <Box style={{flex: 1,paddingLeft:isMobile?"12px":"50px" ,paddingBottom:isMobile?"10px":"0px"}}>
      <Box style={{
         display: 'flex',alignItems: 'center', marginTop: '0px', height: '40px'
     
          }}> 
  {icons.map((icon, index) => (
    <React.Fragment key={index}>
      <Box
        style={{
          paddingRight: index !== icons.length - 1 ? '20px' : '0',
        }}
      >
        <img src={icon.src} alt={icon.alt} style={{width:isMobile?"50px":"auto",height:isMobile?"50px":"auto",objectFit:"contain"}}/>
      </Box>
      {index < icons.length - 1 &&  !isMobile && (
        <Box
          style={{
            borderLeft: '2px solid #27272A', // Vertical line between icons
            marginLeft:isMobile?"2px": '20px',
            height: '100%', // Ensure the line fills the height of the parent
            paddingRight:isMobile?"3px": '20px',
          }}
        />
      )}
 
    </React.Fragment>
  ))}
</Box>
        <CustomText
          style={{
            ...textStyles.h4,
            color: '#072533',
            marginBottom: '10px',
            textAlign: 'left',
            marginTop:"30px",
            maxWidth:isMobile?"250px":"450px",
            fontSize:isMobile?"25px":"32px"
          }}
        >
          {title}
        </CustomText>
        <CustomText
          style={{
            ...textStyles.body3,
            color: '#868282',
            maxWidth: '540px',
            textAlign: 'left',
               marginTop:"15px",
                   maxWidth:"450px"
          }}
        >
          {description}
        </CustomText>



      </Box>

    </Box>
  );
};

export default Card;



